/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DropdownMenu from 'shared/ui/components/DropdownMenu.vue';
import Loader from 'shared/ui/components/Loader.vue';
import ShortenedLink from 'shared/ui/components/ShortenedLink.vue';

// Mixins
import copyLink from 'shared/ui/components/listings/custom-actions/copy-link';

const __vue_script__ = {
    name: 'LiveSessionLinks',

    components: {
        DropdownMenu,
        Loader,
        ShortenedLink
    },

    mixins: [copyLink],

    props: {
        event: {
            type: Object,
            required: true
        },

        item: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            remoteLinks: null,
            inPersonLinks: null,
            displaysLinks: null,
            hostUrl: null
        };
    },

    methods: {
        async onLinksMenuOpen(open) {
            try {
                if (!open) {
                    this.remoteLinks = null;
                    this.inPersonLinks = null;
                    this.displaysLinks = null;
                }

                if (!open || this.loading) {
                    return;
                }

                this.loading = true;
                const eid = this.event._id;

                const sessionType = this.item.session_type ?? 'REMOTE';

                this.hostUrl = await this.$services.deepLink.getLiveStreamHostLink(eid, this.item);

                if (sessionType !== 'IN_PERSON') {
                    const [moderatorLink, speakerLink] = await this.$services.deepLink.getLiveStreamBothLink(eid, this.item, false);
                    this.remoteLinks = [
                        { label: this.$t('live_sessions.details.moderator_link'), link: moderatorLink },
                        { label: this.$t('live_sessions.details.speaker_link'), link: speakerLink }
                    ];
                }

                if (sessionType !== 'REMOTE') {
                    const [moderatorLink, speakerLink] = await this.$services.deepLink.getLiveStreamBothLink(eid, this.item, true);
                    this.inPersonLinks = [
                        { label: this.$t('live_sessions.details.moderator_link'), link: moderatorLink },
                        { label: this.$t('live_sessions.details.speaker_link'), link: speakerLink }
                    ];
                }

                const liveDisplaysLink = await this.$services.liveDisplay.getDocuments(eid, this.item._id);

                if (liveDisplaysLink?.length) {
                    this.displaysLinks = [];
                    const links = await Promise.all(liveDisplaysLink.map(display => this.$services.deepLink.getLiveStreamLiveDisplayLink(eid, this.item, display._id)));
                    for (let i = 0; i < links.length; i++) {
                        this.displaysLinks.push({ label: liveDisplaysLink[i].name, link: links[i] });
                    }
                }

            } catch (error) {
                console.error('[LiveSessionsList] Could not load links', error.message);
                this.$emit('error', this.$i18n.t('general.try_later'));
            } finally {
                this.loading = false;
            }
        },

        async onOptionSelect(option) {
            this.copyLink(option.link);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "live-session-links" },
    [
      _c(
        "dropdown-menu",
        {
          attrs: { "anchor-pos": "ne" },
          on: {
            "activator-click": function (isOpen) {
              return _vm.onLinksMenuOpen(isOpen)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "toggler",
              fn: function (ref) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-icon single",
                      attrs: { type: "button" },
                    },
                    [_c("i", { staticClass: "ic-link" })]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm.loading
            ? _c("loader", {
                staticClass: "static small",
                attrs: { status: true },
              })
            : _c(
                "div",
                { staticClass: "links" },
                [
                  _vm.hostUrl
                    ? [
                        _c("h5", [
                          _vm._v(_vm._s(_vm.$t("live_sessions.details.host"))),
                        ]),
                        _c("ul", [
                          _c("li", [
                            _c(
                              "button",
                              {
                                staticClass: "btn-list-action",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onOptionSelect({
                                      link: _vm.hostUrl,
                                    })
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", { staticClass: "ic-link" }),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "content" },
                                  [
                                    _c("shortened-link", {
                                      attrs: { url: _vm.hostUrl },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm.inPersonLinks
                    ? [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "live_sessions.details.attending_in_person"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "ul",
                          _vm._l(_vm.inPersonLinks, function (option) {
                            return _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-list-action",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onOptionSelect(option)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", { staticClass: "ic-link" }),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "content" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v(_vm._s(option.label) + ":"),
                                      ]),
                                      option.link
                                        ? _c("shortened-link", {
                                            attrs: { url: option.link },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                  _vm.remoteLinks
                    ? [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("live_sessions.details.attending_remote")
                            )
                          ),
                        ]),
                        _c(
                          "ul",
                          _vm._l(_vm.remoteLinks, function (option) {
                            return _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-list-action",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onOptionSelect(option)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", { staticClass: "ic-link" }),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "content" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v(_vm._s(option.label) + ":"),
                                      ]),
                                      option.link
                                        ? _c("shortened-link", {
                                            attrs: { url: option.link },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                  _vm.displaysLinks
                    ? [
                        _c("h5", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "live_sessions.details.attending_live_displays"
                              )
                            )
                          ),
                        ]),
                        _c(
                          "ul",
                          _vm._l(_vm.displaysLinks, function (option) {
                            return _c("li", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn-list-action",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onOptionSelect(option)
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon" }, [
                                    _c("i", { staticClass: "ic-link" }),
                                  ]),
                                  _c(
                                    "span",
                                    { staticClass: "content" },
                                    [
                                      _c("span", { staticClass: "label" }, [
                                        _vm._v(_vm._s(option.label) + ":"),
                                      ]),
                                      option.link
                                        ? _c("shortened-link", {
                                            attrs: { url: option.link },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/live-session/LiveSessionLinks.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__